import {RedTigerJackpotWidgetConfiguration} from './red-tiger-jackpot-widget.configuration';
import {JackpotWidgetConfiguration} from './jackpot-widget.configuration';
import {HomePageHeaderArena} from "./home-page.configuration";
import {LinkToOfferConfiguration} from "./link-to-offer.configuration";
import {NullableUndefined} from "../../../../common/types/nullable-types";
import {
  CategoryDefinitionId
} from "../../games-filter/filters-categories-definitions/filter-category-definition.interface";
import {GAME_GROUP} from "../../../../common/const/game_groups_consts";
import { TitanJackpotWidgetConfiguration } from './titan-jackpot-widget.configuration';

export interface InfoSideBarConfiguration {
  readonly infoImage: string;
  readonly infoTitle: string;
  readonly infoText: string;
}

export enum ApiListType {
  TOP_PICKS = "TOP_PICKS",
  NEW_GAMES = "NEW_GAMES",
  PLAYERS_LIKE_YOU = "PLAYERS_LIKE_YOU",
  RECENTLY_PLAYED = "RECENTLY_PLAYED",
  STATIC_VIDEO = "STATIC_VIDEO",
  LIVE_CASINO_VIDEO = "LIVE_CASINO_VIDEO",
  BECAUSE_YOU_PLAYED = "BECAUSE_YOU_PLAYED",
}

export interface ListConfiguration {
  readonly title: string;
  readonly display: boolean;
  readonly gamesId: number[];
  readonly isSelfUpdatedByNewest?: boolean;
  readonly forceRoundIcons?: boolean;
}



export interface SeoSectionConfiguration {
  display: boolean;
  componentID: string;
  templateID: string;
  fallbackComponent: string;
}

export interface HeaderArenaConfiguration {
  display: boolean;
  title: string;
  image: string;
  link: string;
}



export interface ArenaCommonConfiguration {
  topImage: string;
  animatedTopImage?: string;
  title: string;
  seoSection: SeoSectionConfiguration;
}

export interface CasinoArenaPromotionalBannerConfiguration {
  templateID: string;
  componentID: string;
  displayListPlace?: number;
  displayRowPlace?: number;
  displayTablePlace?: number;
  fallbackComponent?: string;
}

export interface CasinoArenaConfiguration extends ArenaCommonConfiguration {
  promotionalBanner?: CasinoArenaPromotionalBannerConfiguration
  linkToOffer?: LinkToOfferConfiguration;
  filters: NullableUndefined<string[]>;
  advancedFilters?: {
    categories: {
      id: CategoryDefinitionId;
    }[];
  };
  infoSideBar: InfoSideBarConfiguration;
  swiperGamesList: SwiperGamesListConfiguration[];
  allGamesGrid: ArenaGamesGridConfiguration[];
  orderListsByAI?: boolean;
  arenaType?: string;
  homepageHeader?: HomePageHeaderArena;
}

export interface SwiperGamesListConfiguration extends ListConfiguration {
  readonly title: string;
  readonly display: boolean;
  readonly gamesId: number[];
  readonly gamesAdminRefKey?: string;
  readonly templateType?: string;
  readonly redTigerWidget?: RedTigerJackpotWidgetConfiguration;
  readonly titanJackpotWidget?: TitanJackpotWidgetConfiguration;
  readonly jackpotWidget?: JackpotWidgetConfiguration;
  readonly titleIconClassName?: string;
  readonly useSquareIcons?: boolean;
  readonly showNumberBadge?: boolean;
  readonly useAISortedList?: boolean;
  readonly ignoreNumberOfGamesInAISorting?: number;
  readonly forceListInLayout?: boolean;
  readonly seeAll?: string;
  readonly listId?: number; // should be mandatory??
  readonly shouldInjectUsernameInTitle?: boolean;
  readonly apiListType?: ApiListType;
  readonly allowedGameGroups?: GAME_GROUP[];
}

export interface LiveCasinoHeaderConfiguration {
  display: boolean;
  gameId: number;
  image: string;
}

export interface LiveCasinoPromotionalBannerConfiguration {
  displayTablePlace: number;
  displayRowPlace: number;
  componentID: string;
  templateID: string;
  bannerAdminPlaceholderId?: string;
}

export interface LiveCasinoConfiguration extends ArenaCommonConfiguration {
  promotionalBanner: LiveCasinoPromotionalBannerConfiguration;
  linkToOffer?: LinkToOfferConfiguration
  arenas: {
    gamesId: LiveCasinoHeaderConfiguration[];
  },
  popularTables: LiveCasinoPopularTableConfiguration[];
  customLayout: string;
}

export interface NewLiveCasinoConfiguration extends ArenaCommonConfiguration {
  promotionalBanner: LiveCasinoPromotionalBannerConfiguration;
  arenas: HeaderFilterConfiguration[],
  allGamesGrid: ArenaGamesGridConfiguration[];
  customLayout: string;
  useAISortedList: boolean;
  linkToOffer?: LinkToOfferConfiguration;
}

export interface LiveCasinoPopularTableConfiguration {
  title: string;
  gamesId: number[];
  useAISortedList?: boolean;
  ignoreNumberOfGamesInAISorting?: number;
}

export interface ArenaGamesGridConfiguration extends ListConfiguration {
  readonly listId: number;
  readonly title: string;
  readonly display: boolean;
  readonly useAISortedList?: boolean;
  readonly ignoreNumberOfGamesInAISorting?: number;
  readonly gamesId: number[];
  readonly templateType?: string;
  readonly gamesAdminRefKey?: string;
  readonly useSquareIcons?: boolean;
}

export interface HeaderFilterConfiguration {
  display: boolean;
  title: string;
  image: string;
  filter: string;
  seoPage: string;
  isActiveTabDefault?: boolean;
  maxGamesToShow?: number;
  banners?: {
    promotionalBanner: {
      templateID: string,
      componentID: string,
      bannerAdminPlaceholderId?: string
    }
  }
}

export type ArenaConfiguration = CasinoArenaConfiguration & LiveCasinoConfiguration & NewLiveCasinoConfiguration;

export type ArenasConfiguration = {[key: string]: ArenaConfiguration};

